// EXAMPLE FUNCTION FOR ROUTES

import { responseObject } from "../../classes/types/class-user.types";

async function sendLoginRequest(username: string, password: string): Promise<responseObject | null> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}user/login/submit`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ username, password }),
        });

        const data: responseObject = await response.json();

        if (!data) {
            return null;
        }

        return data;
    } catch (error) {
        console.error(error);
    }
    return null;
}

export default sendLoginRequest;
